(function($) {

    $(document).on('click', '.custom-file-upload .btn-browse', function() {
        let targetInput = $(this).data('target-input');
        let fileInput = $('#' + targetInput);

        fileInput.trigger('click');
    });

    $(document).on('change', '.custom-file-upload input.hidden-file-input', function(event) {
        let id = $(this).prop('id');
        let fileInput = document.getElementById(id);
        let targetContainer = $('#' + $(this).data('target-container'));

        fileInput.files = event.target.files;
        targetContainer.find('.filename').html(event.target.files[0].name);
    });

    window.resizeCustomFileUpload = function() {
        $('.custom-file-upload').each(function() {
            let button = $(this).find('.btn');
            let width = $(this).width() - button.outerWidth() - 16;

            $(this).find('.filename').css('width', width + 'px');
        });
    }

    $(window).on('load', function() {
        resizeCustomFileUpload();
    });

    $(window).on('resize', function() {
        resizeCustomFileUpload();
    });

})(jQuery);